import { Button } from 'app/components'
import { useNotificacoes } from '../../../core/NotificacoesProvider'
import { EnviarNotificacaoButton } from '../../../components/EnviarNotificacaoButton'

export const NotificacoesListToolbar = () => {
  const { marcarTodasComoLidas } = useNotificacoes()

  return (
    <>
      <EnviarNotificacaoButton />
      <Button className='btn-primary' onClick={marcarTodasComoLidas}>
        Marcar todas como lidas
      </Button>
    </>
  )
}
